module.exports = __webpack_public_path__ + "static/media/User-Defined.98048ff6.png";